import { Tool } from './base'

export class TaniumTool extends Tool {
  public readonly toolName = 'Tanium'
  public readonly toolKind = 'edr' as const

  // public generateSearchPermalink(
  //   rootURL: string,
  //   renderedContent: string
  // ): string {
  //   const encodedRenderedContent = encodeURIComponent(renderedContent);
  //   return `${rootURL}`;
  // }
}
